<section style="height: 90%">
  <h1>Salud</h1>
  <app-player-selector (playerSelected)="onPlayerSelected($event)">
    <app-player-health [player]="player"></app-player-health>
  </app-player-selector>
</section>
